import { useNavigation } from "../../hooks/useNavigation";
import { Button } from "../atoms/Button";

export const BackToMyPageButton: React.FC = () => {
  const { navigateToMyPage } = useNavigation();

  return (
    <Button
      btnStyle="secondary"
      text="マイページへ戻る"
      onClick={navigateToMyPage}
    />
  );
};
